import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { InputSelect } from "@app/components/molecules";
import { AccountErrorCode, useAuth, useCitiesByMainTrade, useCitiesLight, useNeighborhoodsByMainTrade } from "@saleor/sdk";
import { AlertNeighborhoodDecision, AlertNeighborhoodWithOutCoverage, AlertSendUbication, MainMenu } from "@temp/components";
import React, { useCallback, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Loader } from "@components/atoms";
import { ChangeAmountProductsContext } from "@temp/contexts";
import { signInType } from "@temp/constants";
import { useNavigate } from "react-router-dom";
import ReactSVG from "react-svg";
import { useAppSelector } from "@temp/redux";
import { neighborhoodMessages } from "@temp/intl";
import { debounce } from "@temp/core/utils";
import * as S from "./styles";
import * as paths from "../../../app/routes/paths";

var closeThinImg = require("../../../images/close_search.svg");

var cityImg = require("../../../images/ecommerce/neighborhood/city.svg");

var neighborhoodImg = require("../../../images/ecommerce/neighborhood/neighborhood.svg");

var neighborhoodNotFoundImg = require("../../../images/ecommerce/neighborhood/notFoundNeighborhood.svg");

var redArrowImg = require("../../../images/ecommerce/neighborhood/redArrow.svg");

var urlFromSelectNeighborhoodEvent = new Event("urlFromSelectNeighborhoodEvent");
export var Neighborhood = function Neighborhood() {
  var _JSON$parse, _user$currentTrade, _user$currentTrade2, _user$currentTrade3, _user$currentTrade4, _user$currentTrade5, _mainTradeData$addres, _mainTradeData$addres2, _data$edges3, _user$currentTrade6, _user$currentTrade7, _citiesData$data, _data$edges4, _data$edges5, _data$pageInfo;

  var navigate = useNavigate();
  var intl = useIntl();
  var searchInputRef = useRef(null);

  var _useAppSelector = useAppSelector(function (state) {
    return state.tradeAttention;
  }),
      hasAttentionAtCurrentTime = _useAppSelector.hasAttentionAtCurrentTime;

  var _useCitiesLight = useCitiesLight(),
      neighborhoodByLatitudeLongitude = _useCitiesLight.neighborhoodByLatitudeLongitude;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      manageNeighborhood = _React$useState4[0],
      setManageNeighborhood = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      loadingNeighborhoodsState = _React$useState6[0],
      setLoadingNeighborhoodsState = _React$useState6[1];

  var _React$useState7 = React.useState([]),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      errorsChangeNeighboorhod = _React$useState8[0],
      setErrorsChangeNeighboorhod = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      errorsSendUbication = _React$useState10[0],
      setErrorsSendUbication = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      showNeighborhoodDecision = _React$useState12[0],
      setShowNeighborhoodDesicion = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      showNeighborhoodWithOutCoverage = _React$useState14[0],
      setShowNeighborhoodWithOutCoverage = _React$useState14[1];

  var _React$useState15 = React.useState(localStorage.getItem("fromProductsToNeighborhoods") !== "true"),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      showSendUbication = _React$useState16[0],
      setShowSendUbication = _React$useState16[1];

  var _React$useState17 = React.useState({
    neighborhoodId: 0,
    neighborhoodName: ""
  }),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      neighborhoodSelectedData = _React$useState18[0],
      setNeighborhoodSelectedData = _React$useState18[1];

  var _useAuth = useAuth(),
      user = _useAuth.user,
      changeNeighborhoodCurrentTrade = _useAuth.changeNeighborhoodCurrentTrade,
      createAnonymousUserAndToken = _useAuth.createAnonymousUserAndToken,
      signOut = _useAuth.signOut;

  var _React$useContext = React.useContext(ChangeAmountProductsContext),
      maxProductsPerCategory = _React$useContext.maxProductsPerCategory;

  var mainTradeData = localStorage.getItem("mainTrade") !== null && localStorage.getItem("mainTrade") !== undefined && localStorage.getItem("mainTrade") ? (_JSON$parse = JSON.parse(localStorage.getItem("mainTrade") || "{}")) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.mainTradeData : "";
  var mainTradeId = (user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : _user$currentTrade.idMainTrade) ? +atob(user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : _user$currentTrade2.idMainTrade).split(":")[1] : mainTradeData ? +atob(mainTradeData === null || mainTradeData === void 0 ? void 0 : mainTradeData.id).split(":")[1] : 0;
  var cityInitialValue = (user === null || user === void 0 ? void 0 : (_user$currentTrade3 = user.currentTrade) === null || _user$currentTrade3 === void 0 ? void 0 : _user$currentTrade3.cityIdMainTrade) ? {
    id: +(user === null || user === void 0 ? void 0 : (_user$currentTrade4 = user.currentTrade) === null || _user$currentTrade4 === void 0 ? void 0 : _user$currentTrade4.cityIdMainTrade),
    name: user === null || user === void 0 ? void 0 : (_user$currentTrade5 = user.currentTrade) === null || _user$currentTrade5 === void 0 ? void 0 : _user$currentTrade5.cityNameMainTrade
  } : mainTradeData === null || mainTradeData === void 0 ? void 0 : (_mainTradeData$addres = mainTradeData.address) === null || _mainTradeData$addres === void 0 ? void 0 : (_mainTradeData$addres2 = _mainTradeData$addres.neighborhood) === null || _mainTradeData$addres2 === void 0 ? void 0 : _mainTradeData$addres2.city;

  var _React$useState19 = React.useState(cityInitialValue),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      cityValue = _React$useState20[0],
      setCityValue = _React$useState20[1];

  var _React$useState21 = React.useState(""),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      searchValue = _React$useState22[0],
      setSearchValue = _React$useState22[1];

  var citiesData = useCitiesByMainTrade({
    mainTradeId: mainTradeId
  }, {
    fetchPolicy: "network-only"
  });

  var _useNeighborhoodsByMa = useNeighborhoodsByMainTrade({
    mainTradeId: mainTradeId,
    cityId: (cityValue === null || cityValue === void 0 ? void 0 : cityValue.id) && isNaN(parseInt(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id, 10)) ? atob(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id).split(":")[1] : cityValue === null || cityValue === void 0 ? void 0 : cityValue.id,
    first: 10,
    search: ""
  }, {
    fetchPolicy: "network-only",
    skip: !(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id)
  }),
      data = _useNeighborhoodsByMa.data,
      loadingNeighborhoods = _useNeighborhoodsByMa.loading,
      loadMore = _useNeighborhoodsByMa.loadMore,
      refetch = _useNeighborhoodsByMa.refetch;

  var handleRefetch = function handleRefetch(searchValueInner) {
    refetch({
      mainTradeId: mainTradeId,
      cityId: (cityValue === null || cityValue === void 0 ? void 0 : cityValue.id) && isNaN(parseInt(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id, 10)) ? atob(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id).split(":")[1] : cityValue === null || cityValue === void 0 ? void 0 : cityValue.id,
      first: 10,
      search: searchValueInner
    });
  };

  var handleDataFromSelectNeighborhood = React.useCallback(function (dataFromSelectNeighborhood, isMounted) {
    var _dataFromSelectNeighb, _dataFromSelectNeighb2, _dataFromSelectNeighb4, _dataFromSelectNeighb5;

    if ((dataFromSelectNeighborhood === null || dataFromSelectNeighborhood === void 0 ? void 0 : (_dataFromSelectNeighb = dataFromSelectNeighborhood.dataError) === null || _dataFromSelectNeighb === void 0 ? void 0 : (_dataFromSelectNeighb2 = _dataFromSelectNeighb.error) === null || _dataFromSelectNeighb2 === void 0 ? void 0 : _dataFromSelectNeighb2.length) > 0) {
      var _dataFromSelectNeighb3;

      if ((dataFromSelectNeighborhood === null || dataFromSelectNeighborhood === void 0 ? void 0 : (_dataFromSelectNeighb3 = dataFromSelectNeighborhood.dataError) === null || _dataFromSelectNeighb3 === void 0 ? void 0 : _dataFromSelectNeighb3.error.findIndex(function (error) {
        return error.code === AccountErrorCode.NEIGHBORHOOD_DOES_NOT_HAVE_COVERAGE;
      })) !== -1) {
        if (isMounted) {
          if (showNeighborhoodDecision) {
            setShowNeighborhoodDesicion(false);
          }

          if (showSendUbication) {
            setShowSendUbication(false);
          }

          setShowNeighborhoodWithOutCoverage(true);
        }
      }
    } else if (errorsChangeNeighboorhod.length > 0 && isMounted) {
      setErrorsChangeNeighboorhod([]);
    }

    if (dataFromSelectNeighborhood === null || dataFromSelectNeighborhood === void 0 ? void 0 : (_dataFromSelectNeighb4 = dataFromSelectNeighborhood.data) === null || _dataFromSelectNeighb4 === void 0 ? void 0 : (_dataFromSelectNeighb5 = _dataFromSelectNeighb4.user) === null || _dataFromSelectNeighb5 === void 0 ? void 0 : _dataFromSelectNeighb5.id) {
      var _dataFromSelectNeighb6;

      if (isMounted) {
        setShowNeighborhoodDesicion(false);
      }

      if (dataFromSelectNeighborhood === null || dataFromSelectNeighborhood === void 0 ? void 0 : (_dataFromSelectNeighb6 = dataFromSelectNeighborhood.data) === null || _dataFromSelectNeighb6 === void 0 ? void 0 : _dataFromSelectNeighb6.hasDifferentTrade) {
        localStorage.removeItem("home_cache");
        localStorage.removeItem("sale_cache");
        localStorage.removeItem("products_cache");
        localStorage.removeItem("category_sale_cache");
        localStorage.removeItem("category_products_cache");
        localStorage.removeItem("subcategory_products_cache");
      }

      localStorage.removeItem("manageNeighborhood");

      if (isMounted) {
        navigate(paths.baseUrl);
      } else {
        localStorage.setItem("urlFromSelectNeighborhood", paths.baseUrl);
        window.dispatchEvent(urlFromSelectNeighborhoodEvent);
      }
    }

    if (isMounted) {
      setLoadingNeighborhoodsState(false);
    }

    localStorage.removeItem("manageNeighborhood");
  }, [setShowNeighborhoodDesicion, setShowSendUbication, setShowNeighborhoodWithOutCoverage, setErrorsChangeNeighboorhod, navigate, setLoading]);
  React.useEffect(function () {
    var isMounted = true;

    if (manageNeighborhood) {
      localStorage.setItem("manageNeighborhood", "true");

      if (user === null || user === void 0 ? void 0 : user.id) {
        changeNeighborhoodCurrentTrade(mainTradeId, neighborhoodSelectedData.neighborhoodId, maxProductsPerCategory + 1, signInType.normal).then(function (response) {
          handleDataFromSelectNeighborhood(response, isMounted);

          if (isMounted) {
            setManageNeighborhood(false);
          }
        });
      } else {
        createAnonymousUserAndToken(mainTradeId, neighborhoodSelectedData.neighborhoodId, maxProductsPerCategory + 1, signInType.normal).then(function (response) {
          handleDataFromSelectNeighborhood(response, isMounted);

          if (isMounted) {
            setManageNeighborhood(false);
          }
        });
      }
    }

    return function () {
      isMounted = false;
    };
  }, [manageNeighborhood]);

  var sendUbication = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (navigator.geolocation) {
                setLoadingNeighborhoodsState(true);
                navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
                    var neighborhood, _neighborhood$data, _neighborhood$data2, _neighborhood$data3, _neighborhood$data4;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return neighborhoodByLatitudeLongitude(position.coords.latitude, position.coords.longitude);

                          case 2:
                            neighborhood = _context.sent;

                            if ((neighborhood === null || neighborhood === void 0 ? void 0 : neighborhood.data) === null) {
                              setErrorsSendUbication([{
                                code: "NEIGHBORHOOD_NOT_FOUND",
                                message: "No se encontró el barrio"
                              }]);
                            } else if ((neighborhood === null || neighborhood === void 0 ? void 0 : neighborhood.data) !== null) {
                              setNeighborhoodSelectedData({
                                neighborhoodId: (neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$data = neighborhood.data) === null || _neighborhood$data === void 0 ? void 0 : _neighborhood$data.id) ? +atob(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$data2 = neighborhood.data) === null || _neighborhood$data2 === void 0 ? void 0 : _neighborhood$data2.id).split(":")[1] : 0,
                                neighborhoodName: neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$data3 = neighborhood.data) === null || _neighborhood$data3 === void 0 ? void 0 : _neighborhood$data3.name
                              });
                              setCityValue(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$data4 = neighborhood.data) === null || _neighborhood$data4 === void 0 ? void 0 : _neighborhood$data4.city);
                              setShowNeighborhoodDesicion(true);
                              setShowSendUbication(false);
                            }

                            setLoadingNeighborhoodsState(false);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }(), function (e) {
                  setShowSendUbication(false);
                  setErrorsSendUbication([e]);
                  setLoadingNeighborhoodsState(false);
                });
              } else {
                setErrorsSendUbication([{
                  code: "GEOLOCATION_ERROR",
                  message: "El navegador no soporta geolocalización"
                }]);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function sendUbication() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleErase = useCallback(function () {
    var _searchInputRef$curre;

    if (searchInputRef && (searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current) && (searchInputRef === null || searchInputRef === void 0 ? void 0 : (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.value)) {
      searchInputRef.current.value = "";
      searchInputRef.current.focus();
    }

    setLoadingNeighborhoodsState(true);
    setSearchValue("");
    handleRefetch("");
  }, []);

  var handleSearchNeighborhood = function handleSearchNeighborhood(e) {
    setLoadingNeighborhoodsState(true);
    handleRefetch(e.target.value);
    setSearchValue(e.target.value);
  };

  var onOptimisedHandleChange = debounce(handleSearchNeighborhood, 800);
  React.useEffect(function () {
    if ((user === null || user === void 0 ? void 0 : user.currentTrade) === null && mainTradeData === "") {
      signOut();
    }
  }, [user, mainTradeData]);
  React.useEffect(function () {
    var _data$edges, _data$edges2;

    if (loadingNeighborhoodsState && (data === null || data === void 0 ? void 0 : data.edges) && ((data === null || data === void 0 ? void 0 : (_data$edges = data.edges) === null || _data$edges === void 0 ? void 0 : _data$edges.length) > 0 || (data === null || data === void 0 ? void 0 : (_data$edges2 = data.edges) === null || _data$edges2 === void 0 ? void 0 : _data$edges2.length) === 0) && !localStorage.getItem("manageNeighborhood")) {
      setLoadingNeighborhoodsState(false);
    }
  }, [data === null || data === void 0 ? void 0 : (_data$edges3 = data.edges) === null || _data$edges3 === void 0 ? void 0 : _data$edges3.length]);
  React.useEffect(function () {
    var handleUrlEvent = function handleUrlEvent() {
      var urlFromSelectNeighborhood = localStorage.getItem("urlFromSelectNeighborhood");

      if (urlFromSelectNeighborhood) {
        localStorage.removeItem("urlFromSelectNeighborhood");
        navigate(urlFromSelectNeighborhood);
      }
    };

    window.addEventListener("urlFromSelectNeighborhoodEvent", handleUrlEvent);
    return function () {
      window.removeEventListener("urlFromSelectNeighborhoodEvent", handleUrlEvent);
    };
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(MainMenu, {
    differentTradeToActual: true,
    gobackNeighborhoods: true,
    goback: false,
    search: false,
    cart: false,
    tradeName: (user === null || user === void 0 ? void 0 : (_user$currentTrade6 = user.currentTrade) === null || _user$currentTrade6 === void 0 ? void 0 : _user$currentTrade6.nameMainTrade) || (mainTradeData === null || mainTradeData === void 0 ? void 0 : mainTradeData.name),
    tradeLogo: (user === null || user === void 0 ? void 0 : (_user$currentTrade7 = user.currentTrade) === null || _user$currentTrade7 === void 0 ? void 0 : _user$currentTrade7.logoImageMainTrade) || (mainTradeData === null || mainTradeData === void 0 ? void 0 : mainTradeData.logoImage)
  }), React.createElement(S.Body, {
    hasAttentionAtCurrentTime: hasAttentionAtCurrentTime
  }, React.createElement(S.NeighborhoodTextLocateMe, null, React.createElement("p", {
    onClick: function onClick() {
      setShowSendUbication(true);
    }
  }, React.createElement(FormattedMessage, {
    id: "@next.pages.NeighborhoodPage.Neighborhood.3217442804",
    defaultMessage: "Locate me"
  }))), React.createElement(S.City, null, React.createElement(InputSelect, {
    label: "Ciudad",
    name: "city",
    defaultValue: cityInitialValue,
    options: citiesData === null || citiesData === void 0 ? void 0 : (_citiesData$data = citiesData.data) === null || _citiesData$data === void 0 ? void 0 : _citiesData$data.citiesByMainTrade,
    value: cityValue,
    onChange: function onChange(value) {
      if (value.id !== cityValue.id) {
        setCityValue(value);
      }
    },
    optionLabelKey: "name",
    optionValueKey: "id"
  })), React.createElement(S.Main, null, React.createElement(S.MainLeft, null, React.createElement(ReactSVG, {
    path: cityImg
  })), React.createElement(S.MainRight, null, React.createElement(S.NeighborhoodTextInput, null, React.createElement(S.NeighborhoodCleanSearch, {
    searchValue: searchValue,
    onClick: searchValue.trim() ? function () {
      return handleErase();
    } : function () {
      if (searchInputRef && (searchInputRef === null || searchInputRef === void 0 ? void 0 : searchInputRef.current)) {
        searchInputRef.current.focus();
      }
    }
  }, React.createElement(ReactSVG, {
    path: closeThinImg
  })), React.createElement("input", {
    type: "text",
    ref: searchInputRef,
    defaultValue: searchValue,
    placeholder: intl.formatMessage(neighborhoodMessages.writeNeighborhood),
    onChange: onOptimisedHandleChange
  })), loadingNeighborhoodsState ? React.createElement(S.WrapperLoading, null, React.createElement(Loader, null)) : React.createElement(React.Fragment, null, React.createElement(S.Neighborhoods, null, (data === null || data === void 0 ? void 0 : (_data$edges4 = data.edges) === null || _data$edges4 === void 0 ? void 0 : _data$edges4.length) === 0 ? React.createElement(S.NeighborhoodNotFound, null, React.createElement(S.NeighborhoodNameNotFound, null, intl.formatMessage(neighborhoodMessages.notFound, {
    neighborhoodName: React.createElement("span", null, searchValue)
  })), React.createElement(S.NeighborhoodIconNotFound, null, React.createElement(ReactSVG, {
    path: neighborhoodNotFoundImg
  }))) : data === null || data === void 0 ? void 0 : (_data$edges5 = data.edges) === null || _data$edges5 === void 0 ? void 0 : _data$edges5.map(function (neighborhood, index) {
    var _neighborhood$node, _neighborhood$node5;

    return React.createElement(S.Neighborhood, {
      key: "".concat(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$node = neighborhood.node) === null || _neighborhood$node === void 0 ? void 0 : _neighborhood$node.id, "-").concat(index),
      onClick: function onClick() {
        var _neighborhood$node2, _neighborhood$node3, _neighborhood$node4;

        setNeighborhoodSelectedData({
          neighborhoodId: (neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$node2 = neighborhood.node) === null || _neighborhood$node2 === void 0 ? void 0 : _neighborhood$node2.id) ? +atob(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$node3 = neighborhood.node) === null || _neighborhood$node3 === void 0 ? void 0 : _neighborhood$node3.id).split(":")[1] : 0,
          neighborhoodName: (neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$node4 = neighborhood.node) === null || _neighborhood$node4 === void 0 ? void 0 : _neighborhood$node4.name) || ""
        });
        setShowNeighborhoodDesicion(true);
      }
    }, React.createElement(S.NeighborhoodIcon, null, React.createElement(ReactSVG, {
      path: neighborhoodImg
    })), React.createElement(S.NeighborhoodName, null, neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$node5 = neighborhood.node) === null || _neighborhood$node5 === void 0 ? void 0 : _neighborhood$node5.name), React.createElement(S.NeighborhoodArrow, null, React.createElement(ReactSVG, {
      path: redArrowImg
    })));
  })), loadingNeighborhoods ? React.createElement(S.Wrapper, null, React.createElement(Loader, null)) : (data === null || data === void 0 ? void 0 : (_data$pageInfo = data.pageInfo) === null || _data$pageInfo === void 0 ? void 0 : _data$pageInfo.hasNextPage) && React.createElement(S.Wrapper, null, React.createElement(Button, {
    testingContext: "loadMoreOrdersButton",
    onClick: function onClick() {
      var _data$pageInfo2;

      loadMore({
        after: data === null || data === void 0 ? void 0 : (_data$pageInfo2 = data.pageInfo) === null || _data$pageInfo2 === void 0 ? void 0 : _data$pageInfo2.endCursor,
        mainTradeId: mainTradeId,
        cityId: (cityValue === null || cityValue === void 0 ? void 0 : cityValue.id) && isNaN(parseInt(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id, 10)) ? atob(cityValue === null || cityValue === void 0 ? void 0 : cityValue.id).split(":")[1] : cityValue === null || cityValue === void 0 ? void 0 : cityValue.id,
        first: 10,
        search: searchValue
      });
    }
  }, React.createElement(FormattedMessage, {
    id: "@next.pages.NeighborhoodPage.Neighborhood.1138265409",
    defaultMessage: "Load more"
  }))))))), showNeighborhoodDecision && React.createElement(AlertNeighborhoodDecision, {
    errors: errorsChangeNeighboorhod,
    city: cityValue.name,
    neighborhood: neighborhoodSelectedData.neighborhoodName,
    hideModal: function hideModal() {
      if (errorsChangeNeighboorhod.length > 0) {
        setErrorsChangeNeighboorhod([]);
      }

      setShowNeighborhoodDesicion(false);
    },
    submit: function submit() {
      setLoadingNeighborhoodsState(true);
      setManageNeighborhood(true);
    },
    loading: loading
  }), showNeighborhoodWithOutCoverage && React.createElement(AlertNeighborhoodWithOutCoverage, {
    neighborhood: neighborhoodSelectedData.neighborhoodName,
    hideModal: function hideModal() {
      if (errorsChangeNeighboorhod.length > 0) {
        setErrorsChangeNeighboorhod([]);
      }

      if (showSendUbication) {
        setShowSendUbication(false);
      }

      if (showNeighborhoodDecision) {
        setShowNeighborhoodDesicion(false);
      }

      setShowNeighborhoodWithOutCoverage(false);
    }
  }), showSendUbication && React.createElement(AlertSendUbication, {
    errors: errorsSendUbication,
    hideModal: function hideModal() {
      if (errorsSendUbication.length > 0) {
        setErrorsSendUbication([]);
      }

      setShowSendUbication(false);
    },
    submit: sendUbication,
    loading: loading
  }));
};